import { render, staticRenderFns } from "./PageMailAll.vue?vue&type=template&id=1d8b1e78&scoped=true&"
import script from "./PageMailAll.vue?vue&type=script&lang=js&"
export * from "./PageMailAll.vue?vue&type=script&lang=js&"
import style0 from "./PageMailAll.vue?vue&type=style&index=0&id=1d8b1e78&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d8b1e78",
  null
  
)

export default component.exports